import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './views/Login';
import Register from './views/Register';
import SubscriberStatisticsView from "./views/SubscriberStatisticsView";
import PrivateRoute from "./routes/PrivateRoute";
import ReleaseDetailView from './views/ReleaseDetailView';
import ChangePasswordView from './views/ChangePasswordView';
import MagazineDetailView from './views/MagazineDetailView';

import ReleaseEditView from "./views/ReleaseEditView";
import DashboardLayout from './views/layouts/DashboardLayout';
import DashboardMain from './views/DashboardMain';
import StatisticsView from './views/StatisticsView';
import Releases from './views/Releases';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Magazines from './views/Magazines';
import Profile from './views/Profile';



function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes under dashboard layout */}
        <Route path="/" element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }>
           <Route index element={<DashboardMain />} />
          <Route path="dashboard" element={<DashboardMain />} />
          {/* <Route index element={<Dashboard />} /> */}
          <Route path="profile" element={<Profile />} />
          <Route path="releases" element={<Releases />} />
          <Route path="magazines" element={<Magazines />} />
          <Route path="releases/:id" element={<ReleaseDetailView />} />
          <Route path="magazines/:id" element={<MagazineDetailView />} />
          <Route path="profile/:id/change-password" element={<ChangePasswordView />} />
          <Route path="releases/:id/edit" element={<ReleaseEditView />} />
          <Route path="statistics" element={<StatisticsView />} />
          <Route path="subscriber-stats/:releaseId/:action" element={<SubscriberStatisticsView />} />
        </Route>
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

// function App() {
//   return (



//     <Router>
//       <Routes>
//         <Route path="/" element={
//           <PrivateRoute>
//             <Dashboard />
//           </PrivateRoute>
//         } />
//         <Route path="/releases/:id" element={
//           <PrivateRoute>
//             <ReleaseDetailView />
//           </PrivateRoute>
//         } />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/dashboard" element={
//           <PrivateRoute>
//             <Dashboard />
//           </PrivateRoute>
//         } />
//         <Route path="/subscriber-stats/:releaseId/:action" element={<SubscriberStatisticsView />} />
//       </Routes>
//     </Router>



//   );
// }

export default App;
